import React, { useState } from "react";

const RCPdf2 = () => {
  const [rcno, setRcno] = useState("");
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const handleGenerate = async () => {
    if (!rcno) return alert("Enter RC Number");

    setLoading(true);

    try {
      const res = await fetch(
        "https://rcfinder.online/api/generate_rc_pdf.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: user.id,
            rcno: rcno
          }),
        }
      );

      const data = await res.json();

      if (data.status) {
        alert("RC Generated Successfully ✅");

        // 🔥 optional auto open PDF
        if (data.pdf_url) {
          window.open(
            `https://rcfinder.online/${data.pdf_url}`,
            "_blank"
          );
        }

      } else {
        alert(data.message);
      }

    } catch (err) {
      console.error(err);
      alert("Server Error");
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>RC PDF Generate</h2>

      <input
        type="text"
        placeholder="Enter RC Number"
        value={rcno}
        onChange={(e) => setRcno(e.target.value.toUpperCase())}
        style={{ padding: "10px", width: "250px", marginRight: "10px" }}
      />

      <button onClick={handleGenerate} disabled={loading}>
        {loading ? "Processing..." : "Generate RC"}
      </button>
    </div>
  );
};

export default RCPdf2;